import { PRODUCT_PAGES } from '../constants/routes';

const collectProductVariants = (basket, forPayOrder = false) => {
  const product_variants = [];
  const comments = [];
  let hashImageMass = [];
  const accomp_products = [];
  basket.forEach((basketItem, j) => {
    if (forPayOrder) {
      hashImageMass = hashImageMass.concat(basketItem.images);
      if (basketItem.comment) comments.push(basketItem.comment);
    }

    if (basketItem.productType === PRODUCT_PAGES.POSTCARDS) {
      const additional_delivery_info = {};
      basketItem.images.forEach((img, id) => {
        additional_delivery_info[img.file_id] = {
          to: basketItem.wishes[id].to,
          from: basketItem.wishes[id].from,
          notes: basketItem.wishes[id].notes,
        };
      });
      const variant = {
        photos: basketItem.images.map(img => ({ page: j, id: img.file_id })),
        product_variant_id: basketItem.productId,
        parent_uid: `ParentUID${basketItem.id}${j}`,
        additional_delivery_info,
        basket_id: basketItem.id,
      };
      for (let i = 0; i < basketItem.numberOfCopies; i += 1) {
        product_variants.push(variant);
      }
    } else if (basketItem.productType === PRODUCT_PAGES.GIFT_CERTIFICATES) {
      for (let i = 0; i < basketItem.numberOfCopies; i += 1) {
        accomp_products.push({ tech_id: basketItem.productId, basket_id: basketItem.id });
      }
    } else if (basketItem.productTypeId === PRODUCT_PAGES.FOTOS) {
      const { length } = basketItem.images;
      for (let i = 0; i < length; i += 1) {
        const imageCol = basketItem.images[i].numberOfCopies;
        for (let q = 0; q < imageCol; q += 1) {
          const img = basketItem.images[i];
          const variant = {
            product_variant_id: basketItem.productId,
            parent_uid: `imageParentUID${basketItem.id}${i}${q}`,
            type: basketItem.type,
            photos: [{ page: j, id: img.file_id }],
            basket_id: basketItem.id,
          };
          if (['photos'].includes(basketItem.productTypeId)) variant.additional_info = { type: basketItem.type };
          product_variants.push(variant);
        }
      }
    } else if (basketItem.productType === PRODUCT_PAGES.FOTOBOOKS) {
      if (forPayOrder) hashImageMass = hashImageMass.concat(basketItem.coverImages);
      for (let i = 0; i < basketItem.numberOfCopies; i += 1) {
        const variant = {
          product_variant_id: basketItem.productId,
          parent_uid: `ParentUID${basketItem.id}${i}`,
          photos: basketItem.images.map((img, index) => ({
            page: index + 1,
            id: img.file_id,
          })),
          shilda_text: basketItem.shilda,
          leather_cover: basketItem.cover,
          covers: basketItem.coverImages.map((img, index) => ({
            page: index + 1,
            id: img.file_id,
          })),
          basket_id: basketItem.id,
        };
        if (
          ['photo-book-RU', 'photo-book-RU-slim', 'photo-book-RU-light', 'photo-book-RU-soft'].includes(
            basketItem.productTypeId
          )
        )
          variant.additional_info = { type: basketItem.type };
        product_variants.push(variant);
      }
    } else {
      const length = basketItem.numberOfCopies;
      if (forPayOrder) hashImageMass = hashImageMass.concat(basketItem.coverImages);
      for (let i = 0; i < length; i += 1) {
        const photos = [];
        basketItem.images.forEach((img, index) => {
          for (let q = 0; q < img.numberOfCopies; q += 1) {
            photos.push({ page: index + 1, id: img.file_id });
          }
        });

        const variant = {
          product_variant_id: basketItem.productId,
          parent_uid: `ParentUID${basketItem.id}${i}`,
          photos,
          covers: basketItem.coverImages.map((img, index) => ({
            page: index + 1,
            id: img.file_id,
          })),
          basket_id: basketItem.id,
        };
        if (['photo-poster-RU', 'futbolki-dlia-vzroslykh'].includes(basketItem.productTypeId))
          variant.additional_info = { type: basketItem.type };
        product_variants.push(variant);
      }
    }
  });
  return {
    accomp_products,
    product_variants,
    comments,
    hashImageMass,
  };
};

export default collectProductVariants;
